// extracted by mini-css-extract-plugin
export default {"closeButton":"styles-module__closeButton___Dv5Al","closeIcon":"styles-module__closeIcon___zc7HU"};